import {Pipe, PipeTransform} from '@angular/core';
import {chunk} from 'lodash-es';

/* Lodash's chunk operator in Pipe form
 * https://lodash.com/docs/4.17.15#chunk
 *
 * This splits an array into an array of arrays with the given size.
 * This is being imported for the index page to divide the list of entries into
 * rows.
 */
@Pipe({
  name: 'chunk',
  standalone: true,
})
export class ChunkPipe implements PipeTransform {
  transform<T>(array: ReadonlyArray<T>, size: number = 1): ReadonlyArray<ReadonlyArray<T>> {
    return chunk(array, size);
  }
}
